export const ICTH_THEME = "ice-cream" as const;

export const ICTH_LOGO = {
  src: "https://static.easysunday.com/logo/icecream-white-logo.svg",
  href: "https://www.icecream.co.th",
  alt: "Ice Cream Insurance",
};

export const ICTH_FOOTER_ASSET_BASE_URL =
  "https://static.easysunday.com/sunday-component-v3/logo/footer";
